import React from 'react';

import CheckmarkListItem, {
  CheckmarkListItemProps,
} from '../CheckmarkListItem';

import { Body1, Heading3 } from '../Typography';

import styles from './index.module.scss';

export interface TextWithCheckboxListItemsBlockProps {
  title: string;
  description?: string;
  listItems?: CheckmarkListItemProps[];
}

const TextWithCheckboxListItemsBlock: React.FC<
  TextWithCheckboxListItemsBlockProps
> = ({ title, description, listItems }) => {
  return (
    <div className={styles.wrapper}>
      <Heading3 className={styles.title}>{title}</Heading3>
      {description && (
        <Body1 className={styles.description}>{description}</Body1>
      )}

      {listItems && listItems.length > 0 && (
        <ul className={styles.listWrapper}>
          {listItems.map((item) => (
            <CheckmarkListItem
              key={item.text}
              text={item.text}
              isCheckmarkWhite={false}
            />
          ))}
        </ul>
      )}
    </div>
  );
};

export default TextWithCheckboxListItemsBlock;
